import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import SimpleDate from '../../../components/common/date';
import { isArray } from 'util';

class ProfilePageHeader extends PureComponent {
  constructor(props) {

    super(props);
  }
  formatDate = (value,langCode) => {

    const dateFormatOptions = {
      day: 'numeric', month: 'short', year:'numeric'
     }
    return new Intl.DateTimeFormat(langCode || 'en', dateFormatOptions).format(new Date(value));
  }

  render() {
    const {
      i18n: { messages },
      auth:{
        langCode
      },
      timeValue,
    } = this.props;
    const receivedDate = this.formatDate(timeValue, langCode);
    return (
      <div aria-label={`${messages['app.profile.usersession']} ${receivedDate} ${messages['app.profile.SGT'].split('').join(" ")}`}> 
      <Text secondary id="text_userSession_profilePageHeader_test">
        {messages['app.profile.usersession']}
        {` ${receivedDate} `}
        {messages['app.profile.SGT']}
      </Text>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    auth:{
      langCode: true
    }
  },
})(ProfilePageHeader);
